/** Where a user lands right after login, based on role. Shared by Login and route redirects. */
export function getRoleHomePath(roles = []) {
  if (roles.includes('admin') || roles.includes('super-admin')) return '/admin';
  return '/dashboard';
}
